<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('homework.actionForm') }}</legend>
                <action-form-component v-model="model" :validate="errors">
                  <template v-slot:button-action>
                    <ts-button
                      class="mr-2"
                      @click.prevent="$router.push({ name: 'homework' })"
                      >{{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                      outline
                      color="primary"
                      class="mr-2"
                      :waiting="waiting_new"
                      @click.prevent="onSaveAddNew"
                      >{{ $t('save_add_new') }}</ts-button
                    >
                    <ts-button
                      color="primary"
                      :waiting="waiting"
                      @click.prevent="onSave"
                      >{{ $t('save') }}</ts-button
                    >
                  </template>
                </action-form-component>
              </fieldset>
            </form>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <fieldset>
                <legend>{{ $t('homework.attachmentFile') }}</legend>
                <homework-attach-file v-model="model" />
                <br />
                <training-tool-attachFile v-model="model" />
              </fieldset>
            </form>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import ActionFormComponent from './component/action-form'
import HomeworkAttachFile from './component/homework-attach-file'
import TrainingToolAttachFile from './component/training-tool-attach-file'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'StaffHomeworkCreate',
  components: {
    ActionFormComponent,
    HomeworkAttachFile,
    TrainingToolAttachFile
  },
  data() {
    return {
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        homework_date: moment(),
        class_id: '',
        teacher_id: '',
        subject_id: '',
        remarks: '',
        submission_end_date: moment().add(7, 'Day'),
        reference_url: [],
        attach_file_list: []
      }
    }
  },
  methods: {
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('eschool/staffHomework/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'homework' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.$store
        .dispatch('eschool/staffHomework/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      ;(this.model.homework_date = moment()),
        (this.model.class_id = ''),
        (this.model.teacher_id = ''),
        (this.model.subject_id = ''),
        (this.model.remarks = ''),
        (this.model.submission_end_date = moment().add(7, 'Day')),
        (this.model.reference_url = []),
        (this.model.attach_file_list = [])
      this.$children[1].clearHomeworkAttachFile()
      this.$children[2].clearTrainingAttachFile()
    }
  }
}
</script>
